export default class DefaultMuncher {
  data: any

  /**
   * DefaultMuncher - This class is a fallback muncher in order to render the data
   * in a scatterplot chart or a table chart,  besides this muncher does not generate
   * a datastructure for a scatterplot chart or a table chart.
   *
   * @constructor
   * @param data - Provide the raw data from report content controller
   */
  constructor(data: any) {
    this.data = data
  }

  /**
   * call - This method returns the data structure to print a table chart
   * or a scatterplor chart.
   *
   * @method
   */
  call() {
    return this.data
  }
}
